export default __webpack_public_path__ + "static/media/breathe2.e1a404fd.gif";